<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
          <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
          <h4 style="margin-left: 10px">RF Mobile Management</h4>
        </div>
        <div class="flex items-center">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="showUploadInit" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            :to="{ name: 'rfmanagement-view', params: {id: selectedId} }"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="menus"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        :headerHeight="35"
        :rowHeight="35"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
      <vs-prompt @accept="uploadOrder" title="Upload APK RF Mobile" :active.sync="showUpload">
          <div class="con-exemple-prompt">
              <vs-input class="mb-2 w-full" 
                    v-model="uploadData.version_number" label="Version Number" />

              <vs-input class="mb-2 w-full" 
                    v-model="uploadData.version_code" label="Version Code" />

              <vs-textarea class="mb-2 w-full" height="50" 
                    v-model="uploadData.update_notes" label="Update Notes" />

              <label class="vs-input--label">Force Update</label>
              <vs-select
                  class="selectExample"
                  v-model="uploadData.force_update"
                  width="100%"
                  autocomplete>
                  <vs-select-item value="0" text="False"/>
                  <vs-select-item value="1" text="True"/>
              </vs-select>

              <label class="vs-input--label">File</label>
              <vs-upload
                  class="mb-2 w-full" 
                  :showUploadButton="false"
                  :text="fileName"
                  ref="file_name" />

          </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      fileName: "Select file (.apk)", 
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      showUpload: false,
      menus: [],
      filter: {
        url: "",
        update_notes: "",
        version_number: "",
        version_code: "",
      },
      uploadData: {
          file_name: null,
          update_notes: '',
          version_number: null,
          version_code: '',
          force_update: 0
      },
      parents: [],
      selectedId: null,
      isLoading: false,
      totalPage: 1,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .get("rf/getallapk?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.menus = resp.data.data.map(item => {
            return {
              id: item.id,
              url: item.url,
              update_notes: item.update_notes,
              version_number: item.version_number,
              version_code: item.version_code,
              force_update: item.force_update
            };
          });

          this.totalPage = resp.data.last_page;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.currentPage = resp.data.current_page;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: resp,
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    uploadFile(event, { endpoint }) {
        let formData = new FormData();
        formData.append("file", event.target.files[0]);
        this.isLoading = true;
        this.$http.post(endpoint, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(resp => {
            this.isLoading = false;
            const message = resp.data.message || 'Upload success.'
            this.fetchData();
            this.$vs.notify({
                color: "success",
                title: "Success",
                text: message
            });
        })
        .catch(error => this.handleError(error))
    },
    uploadOrder() {
        this.isLoading = true;

        let formData = new FormData();
        formData.append("file_name", this.uploadData.file);

        this.$http.post('rf/uploadapk', formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "update_notes": this.uploadData.update_notes,
                "version_number": this.uploadData.version_number,
                "version_code": this.uploadData.version_code,
                "force_update": this.uploadData.force_update
            }
        })
        .then(async resp => {
            this.isLoading = false;
            const message = resp.data.message || 'Upload success.'
            this.fetchData();
            this.$vs.notify({
                color: "success",
                title: "Success",
                text: message
            });
        })
        .catch(error => this.handleError(error))
    },
    resetUploadForm() {
        this.uploadData.update_notes = "";
        this.uploadData.version_number = "";
        this.uploadData.version_code = "";
        this.uploadData.force_update = 0;
        this.fileName = "Select file (.apk)";
    },
    showUploadInit() {
        this.isLoading = true;
        this.uploadData.file = null;
        this.resetUploadForm();

        this.showUpload = true;
        setTimeout(() => {
            this.$watch(() => {
                return this.$refs.file_name.filesx[0];
            }, val => {
                this.getSelectedFile();
            });

            this.isLoading = false;
        }, 100);
    },
    getSelectedFile() {
        const files = this.$refs.file_name.filesx;

        if(files.length > 1) {
            files.splice(0, 1);
        }

        const file = files[0];

        if(file) {
            const filetype = file.type;
            console.log(filetype);
            if(filetype !== 'application/vnd.android.package-archive') {
                files.splice(0, 1);
                this.uploadData.file = null;

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Invalid file format',
                })
            }
            else {
                this.uploadData.file = file;
                this.fileName = file.name;
            }
        }
    },
    // removeItem() {
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: "Confirm",
    //     text: "Are you sure want to delete this Menu?",
    //     accept: this.acceptAlert
    //   });
    // },
    // acceptAlert() {
    //   this.isLoading = true;
    //   this.$http
    //     .delete("rolemanagement/menu/" + this.selectedId + "/destroy")
    //     .then(res => {
    //       this.$vs.notify({
    //         color: "success",
    //         title: "Menu deleted",
    //         iconPack: "feather",
    //         icon: "icon-check",
    //         text: "The selected Menu was successfully deleted"
    //       });
    //     })
    //     .catch(error => {
    //       this.$vs.notify({
    //         title: "Error",
    //         text: "Error.",
    //         color: "danger"
    //       });
    //     })
    //     .then(() => {
    //       this.fetchData();
    //     });
    // },
    viewData() {
      this.$router.push({
        name: "rfmanagement-view",
        params: {
          id: this.selectedId
        }
      });
    },

    back() {
      this.$router.push({ name: "rfmanagement" });
    },
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "URL",
        field: "url",
        width: 300
      },
      {
        headerName: "Update Notes",
        field: "update_notes",
        width: 150
      },
      {
        headerName: "Version Number",
        field: "version_number",
        width: 140
        // pinned: 'left'
      },
      {
        headerName: "Version Code",
        field: "version_code",
        width: 125
      },
      {
        headerName: "Force Update",
        field: "force_update",
        width: 130
      },
    ];
  }
};
</script>